import { render } from "./App.vue?vue&type=template&id=740d8b5a"
const script = {}

import exportComponent from "U:\\workspace\\kefu-master\\socket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__